import { apiCall } from "../configs/axiosConfigs";
const BASE_URL = `/ecommerce/discount`;

const withQuery = (base, params) => {
  if (!params) return base;
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
  return qs ? `${base}?${qs}` : base;
};

export const discountApi = {
  async getShippingDiscount(payload) {
    return apiCall({
      url: `${BASE_URL}/shippingDiscount`,
      method: "POST",
      data: payload
    });
  },
  async validarCupon(payload) {
    return apiCall({
      url: `${BASE_URL}/validar`,
      method: "POST",
      data: payload
    });
  },
  async obtenerReglasAutomaticas(payload) {
    return apiCall({
      url: `${BASE_URL}/reglas-automaticas`,
      method: "POST",
      data: payload
    });
  }
};

export const urlMakePageFetcherArtist = {
  url: `${BASE_URL}/shippingDiscount`,
  method: "POST"
};

export { withQuery };
